import createReducer from "utils/createReducer"

export const getProviderSelectOptions = (state, service) => {
  const options = state.providers[service]

  if ( options == undefined) {
    return []
  }

  return Object.keys(options).map((key) => (
    { label: options[key].name, value: options[key].name }
  ))
}

export const getRepaymentTypeSelectOptions = (state, service) => {
  // TODO: Maybe we should get these from the server
  return [
    {value: 'principalAndInterest', label: 'Principal and interest'},
    {value: 'interestOnly', label: 'Interest only'},
  ]
}

export const getRepaymentWaysTypeSelectOptions = (state, service) => {
  // TODO: Maybe we should get these from the server
  return [
    {value: 'clearInFull', label: 'Clear in full'},
    {value: 'minimumRepayment', label: 'Minimum repayment'}
  ]
}

export const getRepaymentWaysTypeOptions = (state) => {
  const repaymentWays = getRepaymentWaysTypeSelectOptions(state)
  const repaymentWaysObject = {}

  repaymentWays.map(function(item) {
    repaymentWaysObject[item.value] = item.label
  })

  return repaymentWaysObject
}

export const getOccupationSelectOptions = (state) => {
  const options = state.occupations

  if ( options == undefined) {
    return []
  }


  return Object.keys(options).map((key) => (
    { label: options[key].name, value: options[key].name }
  ))
}

export const getEmploymentTypeSelectOptions = (state) => {
  const options = state.employment_types

  if ( options == undefined) {
    return []
  }

  return Object.keys(options).map((key) => (
    { label: options[key].name, value: options[key].name }
  ))
}

export const getIncomeOptions = (state) => {
  return state.incomes
}

export default createReducer(gon.options)({})
